<template>
    <div id="unit-info-panel" :class="{centerPanel: !(unitObject.seaLevel || unitObject.groundLevel)}">
        <span :style="{color: `var(--team-${unitObject.team})`}" :class="{margin: unitObject.seaLevel || unitObject.groundLevel }"> {{ unitObject.name }} </span>
        <span class="groundLevel" :class="{margin: unitObject.seaLevel}" v-if="unitObject.groundLevel">  {{ unitObject.groundLevel }} </span>
        <span class="seaLevel" v-if="unitObject.seaLevel">  {{ unitObject.seaLevel }} </span>
    </div>
</template>

<script>
export default {
    props: {
        unitObject: {
            type: Object,
            required: true
        },
    }
}
</script>

<style scoped>
#unit-info-panel{
    background-color: white;
    border: 1px solid black;
    transform: translate(-35%, -125%);
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 4px;
    width: fit-content;
    height: min-content;
    font-size: 1.05em;
    position: fixed;
    z-index: 1;
}
.groundLevel{
    color: rgb(201, 204, 0);
}
.seaLevel{
    color: #00adb5;
}
.margin{
    margin-right: 5px;
}
.centerPanel{
    margin-left: 10px;
}
</style>